import { CubeTextureLoader } from 'three'

import { HDRCubeTextureLoader } from 'three/examples/jsm/loaders/HDRCubeTextureLoader'

export class TextureLib {
  constructor () {
    this.promises = []

    this.promises.push(new Promise(resolve => {
      this.envMap = new CubeTextureLoader().setPath( '/cubemaps/2/' ).load([
        'px.png',
        'nx.png',
        'py.png',
        'ny.png',
        'pz.png',
        'nz.png'
      ], resolve)
    }))

    this.promise = Promise.all(this.promises)
  }
}

export const textureLib = new TextureLib()